/**
 * 分类相关API接口
 */

import { req } from '../utils/request'

export class Category {
  /**
   * 获取分类列表（树级结构）
   * @param {Object} params - 请求参数
   * @returns {Promise}
   */
  getList(params = {}) {
    return req.post('user.article/getCategoryList', params)
  }

  /**
   * 获取首页文章列表
   * @param {string} ident - 分类标识（必填）
   * @returns {Promise<Array>} 返回分类及其文章列表
   * @author Aewin (2021-11-26)
   */
  getTopList(param) {
    return req.post('user.article/getList', param)
  }

  /**
   * 通过会员信息查询证书
   * @param {Object} params - 请求参数
   * @param {string} params.name - 会员姓名（必填）
   * @param {string} params.mobile - 手机号（必填）
   * @returns {Promise<Array>} 返回证书列表
   * @author System (2024-01-21)
   */
  queryByMember(params) {
    return req.post('user.certificate/queryByMember', params)
  }

  /**
   * 通过证书编号查询
   * @param {Object} params - 请求参数
   * @param {string} params.certificate_no - 证书编号（必填）
   * @returns {Promise<Array>} 返回证书详细信息
   * @author System (2024-01-21)
   */
  queryByCode(params) {
    return req.post('user.certificate/queryByCode', params)
  }

  /**
   * 查询公开的注册会员列表
   * @param {Object} params - 请求参数
   * @returns {Promise<Array>} 返回公开会员列表
   * @author System (2024-03-06)
   */
  publicList(params) {
    return req.post('user.member/publicList', params)
  }

  /**
   * 获取会员详情
   * @param {Object} params - 请求参数
   * @returns {Promise<Object>} 返回会员详细信息
   * @author System (2024-03-06)
   */
  detail(params) {
    return req.post('user.member/detail', params)
  }

  /**
   * 根据标识获取文章详情
   * @param {Object} params - 请求参数
   * @param {string} params.$ident - 文章标识（必填）
   * @returns {Promise<Array>} 返回文章详细信息
   * @description 根据文章标识获取文章详细信息，并自动增加阅读次数
   * @author System (2026-03-07)
   */
  getDetailByIdent(params) {
    return req.post('user.article/getDetailByIdent', params)
  }

   /**
    * 创建会费支付订单
    * @param {Object} params - 请求参数
    * @param {number} params.payment_type - 支付类型：1-微信 2-支付宝（必填）
    * @param {string} params.payment_method - 支付方式：mp/h5/wxapp/app/page/faceToFace（必填）
    * @param {number} params.member_level - 会员等级：1-普通 2-注册（必填）
    * @param {number} params.year - 缴费年份，默认当前年份（可选）
    * @param {string} params.openid - 微信openid（公众号/小程序必填）
    * @param {string} params.sub_openid - 子商户openid（可选）
    * @param {string} params.return_url - 支付完成跳转地址（H5/PC需要）
    * @param {string} params.auth_code - 付款码（当面付需要）
    * @param {string} params.remark - 备注（可选）
    * @returns {Promise<Object>} 返回支付订单信息
    * @author System (2026-03-10)
    */
   createPayment(params) {
     return req.post('user.member/createPayment', params)
   }

   /**
    * 获取会费配置
    * @param {Object} params - 请求参数
    * @param {number} params.member_type - 会员类型：1-个人 2-机构 3-理事（必填）
    * @param {number} params.member_level - 会员等级：1-普通 2-注册（必填）
    * @param {number} params.year - 年份，默认当前年份（可选）
    * @returns {Promise<Object>} 返回会费配置信息
    * @author System (2026-03-15)
    */
   getFeeConfig(params) {
     return req.post('user.member/getFeeConfig', params)
   }

   /**
    * 更新会员信息
    * @param {Object} params - 请求参数
    * @returns {Promise<Object>} 返回更新结果
    * @author System (2026-03-15)
    */
   update(params) {
     return req.post('user.member/update', params)
   }

   /**
    * 获取会员信息
    * @param {Object} params - 请求参数
    * @returns {Promise<Object>} 返回会员信息
    * @author System (2026-03-15)
    */
   info(params) {
     return req.post('user.member/info', params)
   }

   /**
    * 搜索文章列表
    * @param {Object} params - 请求参数
    * @param {string} params.keyword - 搜索关键词（可选）
    * @param {number} params.cid - 分类ID（可选）
    * @param {number} params.page - 页码，默认1（可选）
    * @param {number} params.pagesize - 每页数量，默认10（可选）
    * @returns {Promise<Object>} 返回文章列表和分页信息
    */
   searchArticle(params) {
     return req.post('user.article/getList', params)
   }
}

export default new Category()